import { c as _c } from "react/compiler-runtime";
import type { SameTenantDupe } from '@onefootprint/request-types/dashboard';
import { Drawer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import DuplicateUser from '../../duplicate-user';
import DuplicatesLoading from '../../duplicates-loading';
type BankDuplicateDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  dupes: SameTenantDupe[];
  isLoading: boolean;
};
const BankDuplicateDrawer = t0 => {
  const $ = _c(12);
  const {
    isOpen,
    onClose,
    dupes,
    isLoading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "duplicateData.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dupes || $[4] !== isLoading || $[5] !== t) {
    t3 = isLoading ? <DuplicatesLoading /> : <div className="flex flex-col gap-3"><p className="text-body-2 text-primary fp-text">{t(_temp2)}</p>{dupes.map(_temp3)}</div>;
    $[3] = dupes;
    $[4] = isLoading;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== t2 || $[10] !== t3) {
    t4 = <Drawer open={isOpen} onClose={onClose} title={t2}>{t3}</Drawer>;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default BankDuplicateDrawer;
function _temp($) {
  return $.bank.title;
}
function _temp2($_0) {
  return $_0.bank.subtitle;
}
function _temp3(dupe) {
  return <DuplicateUser key={dupe.fpId} dupe={dupe} />;
}